import React from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue,
  Image,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import ComingSoonIMG from '../assets/undraw_under_construction_-46-pa.svg'
import LoadingGIF from '../assets/LoadingGIF.gif'

function ComingSoon() {
  const bgColor = useColorModeValue("gray.100", "gray.900");
  const textColor = useColorModeValue("gray.800", "gray.200");

  return (
    <Box
      bg={bgColor}
      minHeight="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      p={4}
    >
      <VStack spacing={6} textAlign="center">
        {/* Logo or Illustration */}
        <Image
          src={ComingSoonIMG}// Replace this with your own image
          alt="Coming Soon Illustration"
          maxWidth="300px"
        />

        {/* Heading */}
        <Heading as="h1" size="2xl" color={textColor}>
          Coming Soon
        </Heading>

        {/* Description */}
        <Text fontSize="lg" color={textColor}>
          We're working hard to bring something amazing. Stay tuned!
        </Text>

        {/* Go Back Button */}
        {/* <RouterLink to="/">
          <Button colorScheme="blue" size="lg">
            Go Back to Home
          </Button>
        </RouterLink> */}
          <Image
          src={LoadingGIF}// Replace this with your own image
          alt="loading"
          maxWidth="50px"
        />
      </VStack>
    </Box>
  );
}

export default ComingSoon;
